module.exports = __webpack_public_path__ + "img/privacy_policy.d83dd053.svg";